<!-- /src/components/common/Sidebar/TaxonomyGroup.vue -->
<template>
  <div class="sidebar__taxies__group" v-if="taxies">
    <strong class="sidebar__taxies__groupTitle">{{ label }}</strong>
    <ul
      class="sidebar__taxies__groupItems"
      :class="{ 'sidebar__taxies__groupItems--inline': itemStyle == 'inline' }"
    >
      <li
        class="sidebar__taxies__groupItems__item"
        v-for="(tax, i) in taxies"
        :key="i"
      >
        <router-link
          :to="{
            name: sessionType,
            params: { postType },
            query: mkQueryObj(tax),
          }"
          >{{ tax.name }}</router-link
        >
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true,
    },
    taxies: {
      type: Array,
      required: true,
    },
    queryProp: {
      type: String,
      required: true,
    },
    sessionType: {
      type: String,
      required: false,
    },
    postType: {
      type: String,
      required: false,
    },
    'item-style': {
      type: String,
      required: false,
    },
  },
  computed: {
    debug() {
      console.log(this.taxies)
      console.log(this.sessionType)
    }
  },
  methods: {
    mkQueryObj(tax) {
      const output = {}
      output[this.queryProp] = tax.term_id || tax.id
      return output
    },
  },
}
</script>

<style scoped></style>
